import React, { useEffect } from 'react';
// import InputMask from 'react-input-mask';
import {
Box,
TextField,
// Typography,
Divider,
CircularProgress,
Select,
MenuItem,
Typography,
Grid,
// Checkbox,
// FormGroup,
// FormControlLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import RouteConstants from '../../constants/routeConstants';
import { useState, Downgraded, createState } from '@hookstate/core';
import {
    FULL_PERMISSION, NO_ACCESS_PERMISSION, VIEW_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import Title from '../../sharedcomponents/title/title';
import { updateModuleState, useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import { useParams, generatePath, useHistory } from 'react-router-dom';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useAgentState } from '../../hookState/AgentState';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { isEmpty } from 'lodash-es';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';

const ticketState = createState({
    receiptName: '',
    receiptEmail: '',
    contactNumber: '',
    ticketCount: 0,
});

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const CreateTicket = (props) => {

    const classes = useStyles();
    const state = useState(ticketState);
    const loading = useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const [participantList, setParticipantList] = React.useState(null);
    const [eventParticipantList, setEventParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    let params = useParams();
    const history = useHistory();
    const [ticketId, setTicketId] = React.useState(0);
    const [receiptNameErr, setReceiptNameErr] = React.useState('');
    const [emailError, setEmailError] = React.useState('');
    const [receiptEmailErr, setReceiptEmailErr] = React.useState('');
    const [phoneError, setPhoneError] = React.useState('');
    const [partiErrorState, setPartiErrorState] = React.useState(false);
    const [participantNameErr, setParticipantNameErr] = React.useState('');
    const [checkEditPermission, setCheckEditPermission] = React.useState(true);
    const agentState = useAgentState();
    const [snackBarProps, setSnackBarProps] = React.useState({
    openSnack: false,
    variant: 'error',
    message: '',
    });
    const [isParticipant, setIsParticipant] = React.useState(false);
    const [showDetails, setShowDetails] = React.useState(false);
    const [showDetailData, setShowDetailData] = React.useState('');
    const [endUserTicket, setEndUserTicket] = React.useState('');
    const [endUserTicketData, setEndUserTicketData] = React.useState('');
    // const userEvents = Helper.getStorage('UserEvents');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const createdByUser =Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [disableBtn, setDisableBtn] = React.useState(true);
    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {

            if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
            else if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'TICKET')
                    );
                }
            }
            if (endUserTicket !== '' && params.ticketID === undefined) {
                const gEventInfo = Helper.getStorage('eventInfo');
                const path = generatePath(RouteConstants.EDIT_EVENT_TICKET, {
                    eventID: gEventInfo.eventID,
                    ticketID: endUserTicket,
                });
                history.push({
                    pathname: path,
                    state: { ticketState: endUserTicketData },
                });
            }
        }
    }, [eventState]);
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        participant
            ? GetDraftTicketSettingByUserID(agentConnection && gAgentInfo ? gAgentInfo.userID : participant.userID)
            : GetDraftTicketSettingByUserID(agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID);
        if (
            !Helper.isAdminUser(userInfo) ||
            !Helper.isEventAdmin(userInfo) ||
            !Helper.isEventAgent(userInfo) ||
            !Helper.isEventStaff(userInfo)
        ) {
            if (modPermission) {
                if (modPermission == FULL_PERMISSION) {
                    setCheckEditPermission(true);
                } else if (modPermission == VIEW_PERMISSION) {
                    setCheckEditPermission(false);
                } else {
                    setCheckEditPermission(false);
                }
            }
            ApiHelper.get(
                APIURLConstants.GET_TICKETS(
                    gEventInfo.eventID,
                    false,
                    agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID
                )
            )
                .then((res) => {
                    if (res.data.length !== 0) {
                        if (res.data) {
                            // setTimeout(() =>
                            // {
                            //     state.set({
                            //         ...state.get(),
                            //         ticketCount: res?.data[0]?.totalTickets,
                            //     });
                            // }, 1000);
                            const path = generatePath(
                                RouteConstants.EDIT_EVENT_TICKET,
                                {
                                    eventID: gEventInfo.eventID,
                                    ticketID: res?.data[0]?.ticketID,
                                }
                            );
                            setEndUserTicket(res?.data[0]?.ticketID);
                            setEndUserTicketData(res?.data[0]);
                            history.push({
                                pathname: path,
                                state: { ticketState: res?.data[0] },
                            });
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [modPermission]);
    // const getEventDefaults = (userID) =>
    // {
    //     const gEventInfo = Helper.getStorage('eventInfo');
    //     ApiHelper.get(
    //         APIURLConstants.GET_EVENT_DEFAULTS(gEventInfo.eventID, 0, userID)
    //     ).then((res) =>
    //     {
    //         state.set({ ...state.get(), ticketCount: res.data.tickets });
    //     });
    // };
    const GetDraftTicketSettingByUserID = (userID) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_TICKET_SETTING_BYUSERID(gEventInfo.eventID, userID)
        ).then((res) => {
            if (res.data.setting) {
                const transportSettingData = JSON.parse(res.data.setting)
                // console.log("finalSettingData",transportSettingData);
                if (transportSettingData) {
                    // console.log("transportSettingDataasd",transportSettingData);
                    const finalSettingData = JSON.parse(transportSettingData[0].TransportSetting)
                    // console.log("finalSettingData",finalSettingData);
                    if (finalSettingData !== null) {
                        state.set({ ...state.get(), ticketCount: finalSettingData.draftTicketCount });
                    }

                }
            }
        });
    }
    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION || modPermission == VIEW_PERMISSION) {
            if (params.ticketID) {
                if (history.location.state?.ticketState) {
                    const editTicketState = history.location.state.ticketState;
                    setTicketId(params.ticketID);
                    state.set({
                        receiptName: editTicketState.receipentName,
                        receiptEmail: editTicketState.receipentEmail,
                        contactNumber: editTicketState.receipentContact,
                        ticketCount: editTicketState.totalTickets,
                    });
                    GetAdminEventParticipant(
                        eventInfo,
                        userInfo,
                        editTicketState.userID
                    );
                }
            } else {
                resetState();
                GetAdminEventParticipant(
                    eventInfo,
                    userInfo,
                    userInfo.userID
                );
            }
        }
        getModuleDetailsData();
    }, [params.ticketID, modPermission]);

    const getModuleDetailsData = () => {
        if (eventState.eventDetail.get() !== null) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'Ticket') {
                        return true;
                    }
                }); 
            if (!Helper.isAdminUser(userInfo)) {
                if (
                    eventState.eventDetail.get() &&
                    ((index > 0 &&
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            }
        }
    };
    // const sendEmailNotification = (id, data) =>
    // {
    //     const userInfo = Helper.getStorage('userInfo');
    //     let postData = {
    //         ticketID: parseInt(ticketId ? ticketId : 0),
    //         eventID: data.eventID,
    //         userID: data.userID,
    //         participant: participant
    //             ? participant.name
    //             : userInfo.lastName + ', ' + userInfo.firstName,
    //         receipentName: data.receipentName,
    //         receipentEmail: data.receipentEmail,
    //         receipentContact: data.receipentContact,
    //         // requestStatus: history?.location?.state?.ticketState
    //         //     ? history.location.state.ticketState.requestStatus
    //         //     : 'pending',
    //         requestStatus: 'Pending',
    //         totalTickets: data.totalTickets,
    //         createdBy: agentState.visible.value
    //             ? agentInfo.userID
    //             : userInfo.userID,
    //     };
    //     return ApiHelper.post(
    //         APIURLConstants.SEND_TICKET_EMAIL_NOTIFICATION,
    //         postData
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const validateRName = () => {
        let value = state.receiptName.get().trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach(x => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x))
                    isValid = false
            })
        } else {
            isValid = false
        }
        if (value == '') {
            setReceiptNameErr('Please Enter Name');
            return { flag: 'false', messages: 'Please Enter Name' };
        }
        else if (!isValid) {
            setReceiptNameErr('Please Enter Valid Name');
            return { flag: 'false', messages: 'Please Enter Valid Name' };
        } else {
            setReceiptNameErr('');
            return true;
        }
    };
    // console.log("participant",participant);
    const handleSubmit = (event) => {
        event.preventDefault();
        const eventInfo = Helper.getStorage('eventInfo');
            // console.log("ticketCount",state.get().ticketCount);
       
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            let value = participant.userID;
            if (value === 0) {
                setDisableBtn(false);
                setPartiErrorState(true);
                setParticipantNameErr('Please Select Participant');
                return false;
            }
        }
        if (state.get().ticketCount === 0) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Ticket limit exceeds!',
            });
            setDisableBtn(false);
            return
        }
        const tName = validateRName();
        const tEmail = validateREMail();
        const tPhone = checkValidPhone(state.contactNumber.get())
        if (tEmail?.flag === 'false' || phoneError.length > 0 || tName?.flag === 'false' || tPhone?.flag === 'false') {
            setDisableBtn(false);
            return;
        }
        else {
            setDisableBtn(true);
            // debugger 
            const ticketData = {
                TicketID: parseInt(ticketId ? ticketId : 0),
                eventID: eventInfo.eventID,
                userID: agentState.visible.value
                    ? agentState.user.get() && agentState.user.get().userID
                    : isParticipant ? participant
                        ? participant.userID
                        : userInfo.userID : userInfo.userID,

                totalTickets: Number(state.ticketCount.get()),
                receipentName: state.receiptName.get(),
                receipentEmail: state.receiptEmail.get(),
                receipentContact: state.contactNumber.get(),
                isDeleted: false,
                status: 1,
                createdBy: createdByUser.userID,
            };
            ApiHelper.post(APIURLConstants.POST_TICKET, ticketData)
                .then(async (res) => {
                    if (res.data !== '') {
                        if (ticketId > 0) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request updated successfully',
                            });
                        } else {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request created successfully',
                            });
                        }
                        // console.log('ticketData',ticketData);
                        // if (
                        //     Helper.isAdminUser(userInfo.userID) ||
                        //     (userInfo.userID.roles &&
                        //         Helper.isEventAdmin(userInfo.userID)) ||
                        //     (userInfo.userID.roles &&
                        //         Helper.isEventStaff(userInfo.userID))
                        // ) {
                        setDisableBtn(false)
                        let isPublished = eventParticipantList.filter(
                            (x) =>
                                x.isPublished === true &&
                                x.userID === ticketData.userID
                        );
                        // if (isPublished.length > 0) {
                        //     sendEmailNotification(res.data, ticketData);
                        // }
                        // }else{
                        //     sendEmailNotification(res.data, ticketData);
                        // }
                        await updateModuleState();
                        setTimeout(() => {
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
                            ) {
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_TICKETS, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            } else {
                                // ApiHelper.get(
                                //     APIURLConstants.GET_TICKET_BY_TICKETID(
                                //         res?.data
                                //     )
                                // ).then((response) => {
                                //     setEndUserTicket(res?.data);
                                //     setEndUserTicketData(response?.data);
                                //     const path = generatePath(
                                //         RouteConstants.EDIT_EVENT_TICKET,
                                //         {
                                //             eventID: eventInfo.eventID,
                                //             ticketID: res?.data,
                                //         }
                                //     );
                                //     history.push({
                                //         pathname: path,
                                //         state: { ticketState: response?.data },
                                //     });
                                // });
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_DETAIL, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                        }, 1000);
                        loading.set(false);
                    }
                })
                .catch((error) => {
                    loading.set(false);
                    console.log('Error : ', error);
                });
        }
    };
    const handleBtnCancel = () => {
        props.history.goBack();
    };
    const resetState = () => {
        state.set({
            receiptName: '',
            receiptEmail: '',
            contactNumber: '',
            ticketCount: 0,
        });
    };
    const changeParticipant = (participant) => {
        if (participant) {
            // getEventDefaults(participant.userID);
            GetDraftTicketSettingByUserID(participant.userID);
            setPartiErrorState(false);
            setParticipantNameErr('');
        } else {
            setPartiErrorState(true);
            setParticipantNameErr('Please Select Participant');
        }
        setDisableBtn(false)
        setParticipant(participant);
    };
    const GetAdminEventParticipant = (gEventInfo, gUserInfo, userId) => {
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            setIsParticipant(true)
        }
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                const participants = res.data.rows.filter(
                    (participant) =>
                        AppConstants.EVENT_ROLES_VALUES.indexOf(
                            participant.roleName
                        ) == -1
                );
                setEventParticipantList(participants);
                participants.push({
                    userID: 0,
                    name: 'Please Select Participant',
                });
                setParticipantList(history.location.state.participantList);
                if (params.ticketID > 0) {
                    const index = participants.findIndex(
                        (user) => user.userID == userId
                    );
                    if (index > -1) {
                        // getEventDefaults(participants[index]['userID']);
                        GetDraftTicketSettingByUserID(participants[index]['userID']);
                        setParticipant(participants[index]);
                    }
                } else {
                    const index = participants.findIndex(
                        (user) => user.userID == 0
                    );
                    if (index > -1) {
                        setParticipant(participants[index]);
                    }
                }
            }
        });
    };
    // console.log("participantList",participantList);
    const validateREMail = (value) => {
        if (Helper.validEmail(state.receiptEmail.get())) {
            setEmailError(false);
            setReceiptEmailErr('');
            return { flag: 'true' };
        } else if (value == '') {
            setEmailError(false);
            setReceiptEmailErr('');
        } else {
            setEmailError(true);
            setReceiptEmailErr('Please enter valid Email');
            return { flag: 'false' };
        }
    };
    const checkValidPhone = (ph) => {
        state.contactNumber.set(ph)
        // if(state.contactNumber.get() === "" || state.contactNumber.get() === undefined || state.contactNumber.get() === '1'){
        //     setPhoneError('Please enter ticket contact number');
        //     return { flag: 'false' };
        // }else{
        //     setPhoneError('');
        // }
        // if(ph == "" || ph !== state.contactNumber.get() )
        // {
        //     setDisableBtn(false)
        // }
        // else{
        //     setPhoneError('');
        // }
        handleDisableBtn();
        const phone = state.contactNumber.get() ?? '';
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (phone === '') {
            setPhoneError('Please enter phone no');
            return { flag: 'false' };
        } else if (!regex.test(phone)) {
            setPhoneError('Please enter valid phone no');
            return { flag: 'false' };
        } else {
            setPhoneError('');
            return { flag: 'true' };
        }
    };
    const handleDisableBtn = () => {
        if (params.ticketID > 0) {
            const editTicketState = history.location.state.ticketState;
            let prevData = {
                receiptName: editTicketState.receipentName,
                receiptEmail: editTicketState.receipentEmail,
                contactNumber: editTicketState.receipentContact,
                ticketCount: editTicketState.totalTickets,
            }
            let currentData = {
                receiptName: state.get().receiptName,
                receiptEmail: state.get().receiptEmail,
                contactNumber: state.get().contactNumber,
                ticketCount: state.get().ticketCount,
            }

            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }else{
            setDisableBtn(false)
        }

    }

    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                    <Box
                        sx={{
                            width: '100%',
                            backgroundColor: '#fff',
                            '& .MuiFormControl-root': { width: '100%' },
                        }}>
                        <Box
                            component="form"
                            sx={{
                                width: '100%',
                                backgroundColor: '#fff',
                                '& .MuiFormControl-root': { width: '100%' },
                            }}
                            onSubmit={handleSubmit}>
                            <Box>
                                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                                    AppConstants.EVENT_MODULES.DRAFT_TICKET)} />
                            </Box>
                            {showDetails && (
                                <DetailsComponent data={showDetailData} />
                            )}

                            {isParticipant && (
                                <Box
                                    sx={{
                                        width: ' 30%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.3,
                                        justifyContent: 'center',
                                        mx: 'auto',
                                    }}>
                                    <ParticipantAutoList
                                        disableParticipant={
                                            params.ticketID ? true : false
                                        }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={participantList}
                                        modPermission={modPermission}
                                        error={partiErrorState}
                                        errorText={participantNameErr}
                                    />
                                </Box>
                            )}

                            <>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            required
                                            size="small"
                                            // id="outlined-required"
                                            label="Ticket Contact Name"
                                            // onBlur={validateRName}
                                            value={
                                                state.get()
                                                    ? state.receiptName.get()
                                                    : ''
                                            }
                                            disabled={!checkEditPermission}
                                            onChange={(event) => {
                                                state.receiptName.set(
                                                    event.target.value
                                                );
                                                validateRName()
                                                handleDisableBtn();
                                            }}
                                            error={
                                                receiptNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                receiptNameErr.length > 0
                                                    ? receiptNameErr
                                                    : ''
                                            }
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            required
                                            size="small"
                                            // id="outlined-required"
                                            label="Ticket Contact E-Mail"
                                            value={state.receiptEmail
                                                .attach(Downgraded)
                                                .get()}
                                            disabled={!checkEditPermission}
                                            onChange={(event) => {
                                                state.receiptEmail.set(
                                                    event.target.value
                                                );
                                                validateREMail(
                                                    event.target.value
                                                );
                                                handleDisableBtn();
                                            }}
                                            error={emailError}
                                            helperText={
                                                receiptEmailErr.length > 0
                                                    ? receiptEmailErr
                                                    : ''
                                            }
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                    sx={{
                                        padding: 0,
                                        marginTop: 1,
                                        pb: 2,
                                    }}>
                                    <Grid item lg={6} md={6} xs={12}>
                                        {/* <InputMask
                                            mask="(999) 999-9999"
                                            value={state.contactNumber.get()}
                                            defaultValue={state.contactNumber
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(e) =>
                                            {
                                                const ph = e.target.value;
                                                state.contactNumber.set(ph);
                                                checkValidPhone();
                                                handleDisableBtn();
                                            }}
                                        // onBlur={checkValidPhone}
                                        >
                                            {() => (
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    required
                                                    label="Ticket Contact Number"
                                                    // id="outlined-basic"
                                                    variant="outlined"
                                                    value={state.contactNumber.get()}
                                                    error={
                                                        phoneError.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={
                                                        phoneError.length > 0
                                                            ? phoneError
                                                            : ''
                                                    }
                                                />
                                            )}
                                        </InputMask>  */}
                                        <Box sx={{ width: '100%' }}>
                                            <PhoneNumber
                                                name={'ticketContact'}
                                                placeholder="Ticket Contact Number*"
                                                value={state.contactNumber.get()}
                                                onChange={checkValidPhone}
                                                required={true}
                                                disabled={
                                                    !checkEditPermission
                                                        ? !checkEditPermission
                                                        : params.userID > 0
                                                            ? true
                                                            : false
                                                }
                                                helperText={phoneError}
                                                error={phoneError.length > 0 ? true : false}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <Select
                                            size="small"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={state.ticketCount.get()}
                                            // label="Access"
                                            defaultValue={String(
                                                state.ticketCount.get()
                                            )}
                                            disabled
                                            onChange={(event) =>
                                                state.ticketCount.set(
                                                    event.target.value
                                                )
                                            }
                                            sx={{
                                                width: '100%',
                                                backgroundColor: '#cccccc61',
                                            }}>
                                            {(() => {
                                                const options = [];
                                                for (
                                                    let i = 1;
                                                    i <=
                                                    state.ticketCount.get();
                                                    i++
                                                ) {
                                                    options.push(
                                                        <MenuItem
                                                            key={i}
                                                            value={i}>
                                                            <Typography>
                                                                {i}
                                                            </Typography>
                                                        </MenuItem>
                                                    );
                                                }
                                                return options;
                                            })()}
                                        </Select>
                                    </Grid>
                                </Grid>
                                <Divider component="div" />
                                {(() => { 
                                    if (
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo))
                                    ) {
                                        return (
                                            <ButtonContainer
                                                handleCancel={handleBtnCancel}
                                                buttonText={
                                                    ticketId > 0
                                                        ? 'Update'
                                                        : 'Create'
                                                }
                                                disableUpdateButton={params.ticketID !==
                                                    undefined ? disableBtn : false}
                                                disableButton={disableBtn ? true : 
                                                    eventInfo
                                                        .readonlyOrHide === 1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }
                                            />
                                        );
                                    } else {
                                        return (
                                            <ButtonContainer
                                                handleCancel={handleBtnCancel}
                                                buttonText={
                                                    params.ticketID !==
                                                        undefined
                                                        ? 'Update'
                                                        : 'Submit'
                                                }
                                                disableButton={disableBtn ? true :
                                                    eventInfo
                                                        .readonlyOrHide === 1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true : !checkEditPermission
                                                                    ? true
                                                                    : false
                                                            : false
                                                        : false
                                                }
                                                hideCancel={true}
                                                disableUpdateButton={eventInfo
                                                    .readonlyOrHide === 1 ? true : params.ticketID !==
                                                        undefined ? disableBtn : false}
                                                style={{
                                                    width: '50px !important',
                                                }}
                                            />
                                        );
                                    }
                                })()}
                            </>
                        </Box>
                    </Box>
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: false,
                                })
                            }></CustomizedSnackbars>
                    )}
                </Box>
            )}
        </>
    );
};
export default {
    routeProps: {
        path: [
            RouteConstants.CREATE_EVENT_TICKET,
            RouteConstants.EDIT_EVENT_TICKET,
        ],
        component: CreateTicket,
    },
    name: 'CreateTicket',
};
